import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import WebLinkTooltip from "src/shared/forms/tooltips/WebLinkTooltip";
import { length as Length } from "src/shared/forms/validations/Length";
import { required as Required } from "src/shared/forms/validations/Required";
import WebLink from "src/shared/forms/validations/WebLink";

export interface ITermURLInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {}

export default ({
  inputID,
  label = <FormattedMessage id="content.content_url" />,
  validationDisabled = false,
  tooltip = <WebLinkTooltip />,
  ...rest
}: ITermURLInputProps) => {
  const validation = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }

    return [Required, WebLink, Length(undefined, 1024)];
  }, [validationDisabled]);

  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      tooltip={tooltip}
      validate={validation}
      {...rest}
    />
  );
};
